import React from 'react';
import PropTypes from 'prop-types';
import StyledIcon from './Icon.styled';
import {kebabToSnakeCase} from '../utils/helpers/string';
import icons from '../utils/icons';

function Icon({color = 'inherit', name, size = 'medium'}) {
  const code = icons[kebabToSnakeCase(name)] || '';
  return <StyledIcon code={code} color={color} size={size} />;
}

Icon.propTypes = {
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'tertiary']),
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
};

export default Icon;
